// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__lTzJA","clinicsSelect":"TableHeading_clinicsSelect__3f1Z0"};